import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { GoogleAuthProvider } from 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

import { auth } from 'main/utils/firebase';
import { selectUser } from 'main/store/common/selectors';
import { PageTitle } from '../../_common/BasePage/PageTitle';

const CONFIG = {
    signInFlow: 'popup',
    signInOptions: [GoogleAuthProvider.PROVIDER_ID],
    callbacks: {
        signInSuccessWithAuthResult: (_: any) => false
    }
};

export const SignInPage = () => {
    const navigate = useNavigate();
    const user = useSelector(selectUser);

    useEffect(() => {
        user && navigate('/member-only');
    }, [user, navigate]);

    return (
        <Grid container direction="column" pt={1} px={2} spacing={2}>
            <Grid item>
                <PageTitle>サインイン</PageTitle>
            </Grid>
            <Grid item>
                <Typography variant="body2">メンバーページにアクセスするには、下記ボタンをクリックして、Googleアカウントでサインインしてください</Typography>
            </Grid>
            <StyledFirebaseAuth uiConfig={CONFIG} firebaseAuth={auth} />
            <Grid item container direction="column">
                <Typography variant="body2">ただし、利用登録されているユーザのみアクセス可能です</Typography>
                <Typography variant="body2">利用登録を希望の方はチーム関係者に直接確認してください</Typography>
            </Grid>
        </Grid>
    )
}
